import Error from "../utils/Error";
import NewsletterCard from "./NewsletterCard";
import NewsletterSkeleton from "./NewsletterSkeleton";
import { useNewsletters } from "../../hooks/useNewsLetter";

const NewsletterList = ({ children }) => (
  <section className="w-full bg-surface-white pb-20 lg:pb-24">
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-8 px-5 sm:px-6 md:gap-10 md:px-10">
      {children}
    </div>
  </section>
);

const Newsletter2 = () => {
  const { data: newsLetters, isLoading, error, refetch } = useNewsletters();

  if (isLoading)
    return (
      <NewsletterList>
        <NewsletterSkeleton />
      </NewsletterList>
    );

  if (error)
    return (
      <NewsletterList>
        <Error
          title="Newsletter issues aren’t loading"
          message={error.message}
          onRetry={refetch}
        />
      </NewsletterList>
    );

  const issues = Array.isArray(newsLetters?.data) ? newsLetters.data : [];

  return (
    <NewsletterList>
      {issues.length === 0 ? (
        <p className="text-body-lg text-muted">
          No newsletters published yet. Check back soon.
        </p>
      ) : (
        issues.map((item) => <NewsletterCard key={item.id} item={item} />)
      )}
    </NewsletterList>
  );
};

export default Newsletter2;
